import {DeclarationFormField} from "../types/declaration-modal.types";
import {Validators} from "@angular/forms";

export const declarationFormFields: Array<DeclarationFormField> = [
  {
    fieldName: 'declarationNumber',
    label: 'Номер',
    type: 'text',
    validators: [Validators.required]
  },
  {
    fieldName: 'comment',
    label: 'Комментарий',
    type: 'textarea'
  }
]
